import React from "react";
import { Modal, Form, Input, Button, Spin, message, Steps } from "antd";
import { setMemberInfo } from "$DATA/userinfo";
import { translate } from "$ACTIONS/Translate";
import { realyNameRegVietnamese } from "../../actions/reg";
import { showResultModal } from "../../actions/helper";

const { Step } = Steps;
const { Item } = Form;

class RealNameVerify extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
        };
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({ isLoading: true });
                const [first, ...last] = values.realName.split(" ");
                setMemberInfo(
                    {
                        key: "FirstName",
                        value1: values.realName?.trim(),
                    },
                    (res) => {
                        this.setState({ isLoading: false });
                        if (res && res.isSuccess && res.result?.code === "MEM00075") {
                            showResultModal(translate("验证成功"), true, 1501, 'otp', 'authentication-succeeded');
                            this.props.correctMemberInfo();
                            this.props.closeModal();
                            if (this.props.isNext) {
                                this.props.nextStep();
                            }
                        } else {
                            message.error(translate("失败")); //提交失敗
                        }
                    }
                );
            }
        });
    };

    hasErrors = () => {
        const { getFieldsError, isFieldTouched } = this.props.form;
        const errors = getFieldsError();
        const hasTouched = isFieldTouched("realName");
        return Object.keys(errors).some(field => errors[field]) || !hasTouched;
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Modal
                className="general-modal verify-modal"
                width={400}
                visible={this.props.visible}
                title={translate("验证真实姓名")}
                centered={true}
                footer={null}
                maskClosable={true}
                onCancel={() => {
                    this.props.closeModal();
                    this.props.closeWallet && this.props.closeWallet();
                }}
                closable={true}
            >
                <Spin
                    spinning={this.state.isLoading}
                    tip={translate("加载中")}
                    style={{ backgroundColor: "initial" }}
                >
                    <div className="verify-realname">
                        <p>
                            {translate("请输入您的真实姓名作为您银行账户的姓名，以避免存取款交易无法处理。")}
                        </p>
                        <div className="verify-realname-box">
                            <label>
                                <b>
                                    {translate("真实姓名")}
                                </b>
                            </label>
                            <div className="verify-realname-input">
                                <Item>
                                    {getFieldDecorator("realName", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Họ tên thật không được để trống",
                                            },
                                            {
                                                pattern: realyNameRegVietnamese,
                                                message: "Lỗi định dạng, tên thật cần có từ 2-50 ký tự chữ",
                                            },
                                        ],
                                    })(
                                        <Input
                                            placeholder={translate("请输入您的真实姓名")}
                                            size="large"
                                            type="text"
                                            minLength={2}
                                            maxLength={50}
                                            autoComplete="off"
                                        />
                                    )}
                                </Item>
                            </div>
                            <div className="verify-realname-btns">
                                <Button
                                    type="primary"
                                    size="large"
                                    ghost
                                    onClick={() => {
                                        this.props.closeModal();
                                        this.props.closeWallet && this.props.closeWallet();
                                        this.props.onCancel && this.props.onCancel();
                                    }}
                                >
                                    {translate("稍后认证")}
                                </Button>
                                <Button
                                    type="primary"
                                    size="large"
                                    disabled={this.hasErrors()}
                                    onClick={this.handleSubmit}
                                >
                                    {translate("立即验证")}
                                </Button>
                            </div>
                        </div>
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default Form.create({ name: "RealNameVerify" })(RealNameVerify);